var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css"}}),_c('link',{attrs:{"rel":"stylesheet","href":"https://use.fontawesome.com/releases/v5.2.0/css/all.css"}}),_c('Nav'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }